import { useSelector } from "react-redux";
import { tenantSelector } from "@/react/features/customer/customerSlice";
import { useGetTenantInfoQuery } from "@/react/features/vcc/tenant/tenantInfoApi";
import { useErrorNotification } from "@/react/notifications";
import lodash from "lodash";
import { TenantValueIndicator } from "@/react/features/vcc/tenant/TenantValueIndicator";
import styled from "styled-components";
import { ObjectPropertyValueContainer } from "@/react/features/styled/ObjectPropertyValueContainer";
import { ObjectPropertyLabel } from "@/react/features/styled/ObjectPropertyLabel";

const Container = styled.div`
  padding-bottom: 48px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  width: 100%;
`;

const TenantInfoPage = () => {
  const tenant = useSelector(tenantSelector);
  const tenantName = tenant.tenantId;

  const {
    data: tenantInfo,
    isFetching,
    error,
  } = useGetTenantInfoQuery(tenantName);

  useErrorNotification(error);

  return isFetching ? (
    <div>Loading Tenant Information...</div>
  ) : (
    <Container>
      {Object.entries(tenantInfo).map(([property, value], index) => (
        <ObjectPropertyValueContainer key={property}>
          <ObjectPropertyLabel>
            {lodash.startCase(property)}
          </ObjectPropertyLabel>
          <TenantValueIndicator value={value} />
        </ObjectPropertyValueContainer>
      ))}
    </Container>
  );
};

export default TenantInfoPage;
